module.exports = __webpack_public_path__ + "static/img/gb-eng.a8779518.svg";